import { useCallback, useState } from 'react'
import { toast } from 'sonner'
import ProfilePropertiesUnlockImg from '@/assets/images/profile-properties-unlock.png'
import type { ProfilePropertiesUnlockPopoverProps } from '@/components/layout/ProfilePropertiesUnlockPopover.types'
import { Button } from '@/components/ui/button'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'
import { useIntegrationMutations } from '@/hooks/useIntegrations'

export function ProfilePropertiesUnlockPopover({
  children,
}: ProfilePropertiesUnlockPopoverProps) {
  const [open, setOpen] = useState(false)
  const { requestProfilePropertiesContact } = useIntegrationMutations()

  const handleContactUs = useCallback(() => {
    setOpen(false)
    requestProfilePropertiesContact.mutate(undefined, {
      onSuccess: () => {
        toast.success('Thanks! We will be in touch with you shortly.')
      },
      onError: () => {
        toast.error('Something went wrong. Please try again.')
      },
    })
  }, [requestProfilePropertiesContact])

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent
        className="w-[560px] overflow-hidden rounded-3xl border border-border p-0 shadow-lg"
        side="right"
        align="center"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
      >
        <div className="flex gap-6 p-4">
          <div className="w-[200px] shrink-0 overflow-hidden rounded-2xl">
            <img
              src={ProfilePropertiesUnlockImg}
              alt="Unlock Profile Properties"
              className="size-full object-cover"
            />
          </div>

          <div className="flex flex-1 flex-col gap-6 pt-2">
            <div className="flex flex-col gap-1.5">
              <p className="text-base font-semibold text-foreground">
                Unlock Profile Properties
              </p>
              <p className="text-sm text-muted-foreground">
                Turn your conversation data into actionable customer attributes.
                Transform insights gathered through VWAM into structured data
                points that enrich the unified customer profile in BlueConic.
                Capture preferences, intent signals, and engagement behaviors
                and activate them across your marketing ecosystem in real time.
              </p>
            </div>

            <Button
              variant="secondary"
              className="self-end rounded-full"
              onClick={handleContactUs}
            >
              Contact us
            </Button>
          </div>
        </div>
      </PopoverContent>
    </Popover>
  )
}
